import { render, staticRenderFns } from "./CompTabelaExcecoesAjuizamento.vue?vue&type=template&id=5c459f87&scoped=true&"
import script from "./CompTabelaExcecoesAjuizamento.vue?vue&type=script&lang=js&"
export * from "./CompTabelaExcecoesAjuizamento.vue?vue&type=script&lang=js&"
import style0 from "./CompTabelaExcecoesAjuizamento.vue?vue&type=style&index=0&id=5c459f87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c459f87",
  null
  
)

export default component.exports